import { render, staticRenderFns } from "./IngoPolicyCancel.vue?vue&type=template&id=08ac39d6&scoped=true&"
import script from "./IngoPolicyCancel.vue?vue&type=script&lang=js&"
export * from "./IngoPolicyCancel.vue?vue&type=script&lang=js&"
import style0 from "./IngoPolicyCancel.vue?vue&type=style&index=0&id=08ac39d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac39d6",
  null
  
)

export default component.exports